<div class="size-guide-editor" [formGroup]="form">
    <div class="form-group mb-3">
        <label for="sg-name" class="form-label required">{{ "size_guide_name" | translate }}</label>
        <input
            type="text"
            class="form-control"
            id="sg-name"
            formControlName="name"
            [class.is-invalid]="form.get('name')?.invalid && form.get('name')?.touched"
        />
    </div>

    <div class="form-group mb-3">
        <label class="form-label required">{{ "size_guide_measurements" | translate }}</label>
        <app-select formControlName="measurementCodes" [multiple]="true" [options]="measurementOptions" [required]="false"></app-select>
        <small class="text-muted">{{ "size_guide_measurements_hint" | translate }}</small>
        <div class="invalid-feedback d-block" *ngIf="form.get('measurementCodes')?.touched && form.get('measurementCodes')?.invalid">
            {{ "size_guide_measurements_required" | translate }}
        </div>
    </div>

    <div class="form-group mb-3">
        <label class="form-label required">{{ "size_guide_sizes" | translate }}</label>
        <app-select formControlName="sizeCodes" [multiple]="true" [options]="sizeOptions" [required]="false"></app-select>
        <small class="text-muted">{{ "size_guide_sizes_hint" | translate }}</small>
        <div class="invalid-feedback d-block" *ngIf="form.get('sizeCodes')?.touched && form.get('sizeCodes')?.invalid">
            {{ "size_guide_sizes_required" | translate }}
        </div>
    </div>

    <div class="accordion accordion-flush border rounded" *ngIf="columns.length > 0">
        <div class="accordion-item" *ngFor="let col of columns; let ci = index">
            <h2 class="accordion-header">
                <button
                    type="button"
                    class="accordion-button"
                    [class.collapsed]="!accordionOpen[col.name]"
                    (click)="toggleAccordion(col.name)"
                >
                    {{ measurementLabel(col.name) }}
                </button>
            </h2>
            <div class="accordion-collapse" [class.d-none]="!accordionOpen[col.name]">
                <div class="accordion-body">
                    <div class="row g-2">
                        <ng-container *ngFor="let line of lines">
                            <div class="col-6 col-md-4">
                                <label class="form-label small">{{ sizeLabel(line.name) }}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    [formControlName]="line.cells[ci].inputId"
                                    [placeholder]="'Measurement (cm)' | translate"
                                    [class.is-invalid]="form.get(line.cells[ci].inputId)?.invalid && form.get(line.cells[ci].inputId)?.touched"
                                />
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="invalid-feedback d-block" *ngIf="form.touched && form.hasError('valuesRequired')">
        {{ "size_guide_values_required" | translate }}
    </div>
</div>
